/**
 * Triggers a browser download of a file from an S3 presigned URL.
 *
 * Description:
 *   Creates a hidden anchor element with the provided download URL, clicks it, and removes it.
 *
 * Parameters:
 *   fileDownloadUrlString: string - The presigned URL to download from.
 *   suggestedFilenameString: string (optional) - Optional suggested filename for download.
 *
 * Return Value:
 *   void.
 *
 * Exceptions & Errors:
 *   None.
 */
export function triggerAttachmentDownload(
  fileDownloadUrlString: string,
  suggestedFilenameString?: string,
): void {
  if (!fileDownloadUrlString) {
    return;
  }

  const temporaryAnchorElement: HTMLAnchorElement = document.createElement('a');
  temporaryAnchorElement.href = fileDownloadUrlString;
  temporaryAnchorElement.target = '_blank';
  temporaryAnchorElement.rel = 'noopener noreferrer';

  if (suggestedFilenameString) {
    temporaryAnchorElement.download = suggestedFilenameString;
  }

  document.body.appendChild(temporaryAnchorElement);
  temporaryAnchorElement.click();
  document.body.removeChild(temporaryAnchorElement);
}
